import React, {ChangeEvent, ReactNode} from "react";
import {withTranslation} from "react-i18next";
import {withHostApi} from "../../contexts/HostApiContext";
import { InputGroup, InputGroupAddon,Input} from "reactstrap";
import {colorData} from "./iColorData";
import {getRequestConfig, request} from "tunnel-commande/src/utils";

interface CmjnPickerProps {
  c?: number;
  m?: number;
  j?: number;
  n?: number;
  typeTransfer: string;
  colorHexa: string;
  colorData: (colorInfos: colorData) => void;
  hostApi: string;
  selectedFromPickr: boolean;
  t: (arg0: string) => ReactNode;
}

interface CmjnPickerState {
  c: number;
  m: number;
  j: number;
  n: number;
  hexadecimal?: string;
  hsl?: {h:number, s:number, l:number};
  selectedFromPickr: boolean;
}

class CmjnPicker extends React.Component<CmjnPickerProps, CmjnPickerState> {
  private timeoutId: NodeJS.Timeout | undefined;
  constructor(props: CmjnPickerProps) {
    super(props);
    this.state = {
      selectedFromPickr: this.props.selectedFromPickr,
      c: this.props.c ?? 0,
      m: this.props.m ?? 0,
      j: this.props.j ?? 0,
      n: this.props.n ?? 100,
    };
    this.handleChangeInput = this.handleChangeInput.bind(this);
  }

  componentDidMount() {
    this.fetchHsl(this.state.c, this.state.m, this.state.j, this.state.n);
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    if(prevProps !== this.props) {
      this.setState({
        c: this.props.c ?? 0,
        m: this.props.m ?? 0,
        j: this.props.j ?? 0,
        n: this.props.n ?? 100,
        selectedFromPickr: this.props.selectedFromPickr
      }, () => this.convertHexaFromCmyk());
    }
  }

  convertHexaFromCmyk()  {
    if(this.state.selectedFromPickr) {
      this.fetchHsl(this.state.c, this.state.m, this.state.j, this.state.n);
    }
  }

  handleChangeInput(event: ChangeEvent<HTMLInputElement>, name: string) {
    let value = parseInt(event.target.value,10);
    if(value < 0 || isNaN(value)) { value = 0; }
    if(value > 100) { value = 100; }
    if(name === 'c' || name === 'm' || name === 'j' || name === 'n') {

      this.setState({
        hexadecimal: this.state.hexadecimal,
        hsl: this.state.hsl,
        c: this.state.c,
        m: this.state.m,
        j: this.state.j,
        n: this.state.n,
        selectedFromPickr: false,
        [name]: value
      }, () => {
        if (this.props.typeTransfer === 'ce') {
          if (this.timeoutId) {
            clearTimeout(this.timeoutId);
          }
          this.timeoutId = setTimeout(() => {
            this.fetchHsl(this.state.c, this.state.m, this.state.j, this.state.n);
          }, 1000);
        }
      });
    }
  }

  fetchHsl(cyan: number, magenta: number, jaune: number, noir: number) {
    request("GET", `${this.props.hostApi}/colors-class/hsl?cyan=${cyan}&magenta=${magenta}&jaune=${jaune}&noir=${noir}`, {
      ...getRequestConfig()
    }).then((res) => {
      this.setState({
        hsl: res.data.hsl,
        hexadecimal: res.data.hexadecimal,
        selectedFromPickr: false
      }, () => {
        const colorData = {
          id: undefined,
          couleur_libelle: undefined,
          c: this.state.c,
          m: this.state.m,
          j: this.state.j,
          n: this.state.n,
          hexadecimal: this.state.hexadecimal,
          hsl: this.state.hsl,
          marqueId: 0
        }
        if(this.props.colorData) {
          this.props.colorData(colorData);
        }
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  render() {

    const arrayCmjn = [{"libelle": this.props.t('cyan'), "state": "c"}, {"libelle": this.props.t('magenta'), "state": "m"}, {"libelle": this.props.t('jaune'), "state": "j"}, {"libelle": this.props.t('noir'), "state": "n"}];

    return (
        <div className={"mr-2 d-flex "}>
          <div className={'mr-4 align-self-start'} style={{backgroundColor: this.props.colorHexa, width: '100px', height: '35px'}}>&nbsp;</div>
          <div className={'mr-4'}>
          {
            arrayCmjn.map((elt:{"libelle": ReactNode, "state": string}, index ) => {
              return (
                  <div className={"d-flex justify-center mb-1"}  style={{width: '140px'}} key={index}>
                    <span className={"w-25"}>{elt.libelle}</span>

                    <InputGroup>
                    <Input className={`border-dark `} type={"number"} max={100} step="1" onChange={(event) => {
                      this.handleChangeInput(event, elt.state)
                    }} value={elt.state === 'c' || elt.state === 'm' || elt.state === 'j' || elt.state === 'n' ? this.state[elt.state] : 0}/>
                      <InputGroupAddon addonType="append">%</InputGroupAddon>
                    </InputGroup>
                  </div>
              );
            })
          }
          </div>
        </div>
    );
  }
}

export default withTranslation('common')(withHostApi(CmjnPicker));
